// extracted by mini-css-extract-plugin
export default {"root":"offers-tab_root__drqhh","topMetrics":"offers-tab_topMetrics__ZKqIM","count":"offers-tab_count__kWKnk","itemsWrap":"offers-tab_itemsWrap__otCNh"};